import { CommonModule } from '@angular/common';
import { Component, computed, OnInit, signal } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-user-iframe-dialog',
  templateUrl: './user-iframe-dialog.component.html',
  styleUrls: ['./user-iframe-dialog.component.scss'],
  imports: [CommonModule],
})
export class UserIframeDialogComponent implements OnInit {
  src = signal<string>('');
  safeSrc = computed<SafeResourceUrl>(() => {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.src());
  });
  constructor(
    private sanitizer: DomSanitizer,
    public dialogConfig: DynamicDialogConfig,
  ) {}

  ngOnInit() {
    this.src.set(this.dialogConfig?.data?.src);
  }
}
